import { createReducer, on } from '@ngrx/store';

import type { ConsentContainerRendering } from '../../models';
import { setConsentRendering } from './consent-rendering.actions';

export const consentRendering = createReducer<
  ConsentContainerRendering | undefined
>(
  undefined,
  on(setConsentRendering, (_, action) => action.payload)
);
